import { render, staticRenderFns } from "./Templates/FeedbackReasons.html?vue&type=template&id=606b1c7e&external"
import script from "./FeedbacksReason.vue?vue&type=script&lang=js"
export * from "./FeedbacksReason.vue?vue&type=script&lang=js"
import style0 from "./FeedbacksReason.vue?vue&type=style&index=0&id=606b1c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports